// MIST.Web's workspace bar (AppHeader), for both layouts: which workspace this
// is, anything the layout adds, the way back to MIST, and who is signed in, with
// the way in or out. The way back is in the bar, so both layouts and every page
// under them have it.
import type { ReactNode } from 'react';
import { Link } from 'react-router';

import { useMistWebUrl } from '../app/config';
import { canBuild, useSession } from '../auth/session';
import { BrandMark, Button, Icon } from '../design/components';

export function AppBar({
    workspace,
    brandHome,
    children,
}: {
    workspace: string;
    /** Where the brand mark goes, when the layout has no drawer to carry it. */
    brandHome?: string;
    children?: ReactNode;
}) {
    const mistWeb = useMistWebUrl();
    return (
        <header className="sf-appbar">
            {brandHome ? (
                <>
                    <Link to={brandHome} className="sf-brand" aria-label="MIST shop floor home">
                        <BrandMark />
                    </Link>
                    <span className="sf-appbar-divider" aria-hidden="true" />
                </>
            ) : null}
            <div className="sf-workspace">
                <span className="eyebrow sf-workspace-label">Workspace</span>
                <span className="text-md sf-workspace-title">{workspace}</span>
            </div>
            {children}
            <div className="sf-appbar-spacer" />
            {mistWeb ? (
                <a href={mistWeb} className="sf-button sf-button--text">
                    <Icon name="arrowBack" />
                    Back to MIST
                </a>
            ) : null}
            <UserMenu />
        </header>
    );
}

// As MIST.Web's UserMenu: name over role, then a quiet Sign out; a visitor gets Sign in.
function UserMenu() {
    const session = useSession();
    if (!session.signedIn) {
        return (
            <Button icon="login" onClick={session.signIn} disabled={session.loading}>
                Sign in
            </Button>
        );
    }
    return (
        <div className="sf-user">
            <div className="sf-user-identity">
                <span className="text-sm sf-user-name" aria-label="Signed in as">
                    {session.displayName ?? session.username}
                </span>
                <span className="text-xs sf-user-roles">{canBuild(session) ? 'Assembly' : 'Read only'}</span>
            </div>
            <Button variant="text" icon="logout" onClick={session.signOut}>
                Sign out
            </Button>
        </div>
    );
}
